import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="w-full bg-transparent relative z-20 mt-5">
      <div className="mx-auto">
        <div className="flex justify-between items-center mx-4 sm:mx-6 md:mx-8 lg:mx-10 ">
          {/* Left Logo - A.O Smith */}
          {/* <div className="flex items-center flex-shrink-0">
            <img
              src=""
              // alt="A.O Smith"
              className="h-16 sm:h-20 md:h-24 lg:h-32 xl:h-32 w-auto object-contain"
            />
          </div> */}
          <div className="flex items-center flex-shrink-0 h-14 sm:h-16 md:h-20 lg:h-20 xl:h-20 w-auto">
            {/* <img
              src=" "
              // alt="PureIt"
              className="h-14 sm:h-16 md:h-20 lg:h-28 xl:h-28 w-auto object-contain"
            /> */}
          </div>
         
          {/* Right Logo - PureIt */}
          {/* <div className="flex items-center flex-shrink-0">
            <img
              src="https://cdn-icons-png.flaticon.com/128/11699/11699675.png"
              alt="PureIt"
              className="h-14 sm:h-16 md:h-20 lg:h-28 xl:h-28 w-auto object-contain"
            />
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default Header;